export const PORTFOLIO_DETAIL_APPS = new Set(["portfolio", "portfolio-builder"]);

const PORTFOLIO_ID_PARAM_ALIASES = ["id", "portfolioId", "portfolio_id"] as const;

type FocusedWindowLike = {
  appId: string;
  title: string;
  params?: Record<string, string>;
} | null | undefined;

/** Same alias order as `resolveResourceWindowId` in OsAppRegistry (PortfolioWindow). */
function resolveWindowParam(params: Record<string, string> | undefined, aliases: readonly string[]): string | undefined {
  if (!params) {
    return undefined;
  }
  for (const key of aliases) {
    const value = String(params[key] ?? "").trim();
    if (value) {
      return value;
    }
  }
  return undefined;
}

/** Mirrors OsAniSidebar `buildFeContext` app_state shaping for portfolio detail windows. */
export function buildFeAppStateForSend(
  apiData: Record<string, unknown> | undefined,
  focusedWindow: FocusedWindowLike,
): Record<string, unknown> {
  const appState = { ...(apiData ?? {}) };
  delete appState.portfolio_id;
  delete appState.portfolio_name;

  if (focusedWindow && PORTFOLIO_DETAIL_APPS.has(focusedWindow.appId)) {
    const portfolioId = resolveWindowParam(focusedWindow.params, PORTFOLIO_ID_PARAM_ALIASES);
    if (portfolioId) {
      appState.portfolio_id = String(portfolioId);
      appState.portfolio_name = focusedWindow.title;
    }
  }

  return appState;
}
